module.exports = __webpack_public_path__ + "static/media/plan.80d739ab.svg";